"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[961],{

/***/ 961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ FaqAccordion; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
// EXTERNAL MODULE: ../wif-ui-lib/dist/index-099c513a.mjs
var index_099c513a = __webpack_require__(3011);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Icon-3122c134.mjs
var Icon_3122c134 = __webpack_require__(3355);
// EXTERNAL MODULE: ../wif-ui-lib/dist/ArticleSection.js
var ArticleSection = __webpack_require__(2579);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-d6406817.mjs
var Image_d6406817 = __webpack_require__(5905);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
// EXTERNAL MODULE: ../node_modules/react-dom/index.js
var react_dom = __webpack_require__(1542);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/FaqAccordion.js











var P = "Collapsible", [xe, Y] = (0,index_099c513a.b)(P), [Ae, L] = xe(P), J = react.forwardRef(
  (e, c) => {
    const {
      __scopeCollapsible: o,
      open: a,
      defaultOpen: r,
      disabled: n,
      onOpenChange: i,
      ...l
    } = e, [m, u] = (0,index_099c513a.f)({
      prop: a,
      defaultProp: r ?? !1,
      onChange: i,
      caller: P
    });
    return /* @__PURE__ */ index_099c513a.j.jsx(
      Ae,
      {
        scope: o,
        disabled: n,
        contentId: (0,index_099c513a.g)(),
        open: m,
        onOpenToggle: react.useCallback(() => u((v) => !v), [u]),
        children: /* @__PURE__ */ index_099c513a.j.jsx(
          index_099c513a.P.div,
          {
            "data-state": V(m),
            "data-disabled": n ? "" : void 0,
            ...l,
            ref: c
          }
        )
      }
    );
  }
);
J.displayName = P;
var Q = "CollapsibleTrigger", X = react.forwardRef(
  (e, c) => {
    const { __scopeCollapsible: o, ...a } = e, r = L(Q, o);
    return /* @__PURE__ */ index_099c513a.j.jsx(
      index_099c513a.P.button,
      {
        type: "button",
        "aria-controls": r.contentId,
        "aria-expanded": r.open || !1,
        "data-state": V(r.open),
        "data-disabled": r.disabled ? "" : void 0,
        disabled: r.disabled,
        ...a,
        ref: c,
        onClick: (0,index_099c513a.c)(e.onClick, r.onOpenToggle)
      }
    );
  }
);
X.displayName = Q;
var q = "CollapsibleContent", Z = react.forwardRef(
  (e, c) => {
    const { forceMount: o, ...a } = e, r = L(q, e.__scopeCollapsible);
    return /* @__PURE__ */ index_099c513a.j.jsx(index_099c513a.h, { present: o || r.open, children: ({ present: n }) => /* @__PURE__ */ index_099c513a.j.jsx(Ie, { ...a, ref: c, present: n }) });
  }
);
Z.displayName = q;
var Ie = react.forwardRef((e, c) => {
  const { __scopeCollapsible: o, present: a, children: r, ...n } = e, i = L(q, o), [l, m] = react.useState(a), u = react.useRef(null), v = (0,index_099c513a.u)(c, u), g = react.useRef(0), x = g.current, b = react.useRef(0), f = b.current, A = i.open || l, I = react.useRef(A), N = react.useRef(void 0);
  return react.useEffect(() => {
    const d = requestAnimationFrame(() => I.current = !1);
    return () => cancelAnimationFrame(d);
  }, []), (0,index_099c513a.i)(() => {
    const d = u.current;
    if (d) {
      N.current = N.current || {
        transitionDuration: d.style.transitionDuration,
        animationName: d.style.animationName
      }, d.style.transitionDuration = "0s", d.style.animationName = "none";
      const E = d.getBoundingClientRect();
      g.current = E.height, b.current = E.width, I.current || (d.style.transitionDuration = N.current.transitionDuration, d.style.animationName = N.current.animationName), m(a);
    }
  }, [i.open, a]), /* @__PURE__ */ index_099c513a.j.jsx(
    index_099c513a.P.div,
    {
      "data-state": V(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !A,
      ...n,
      ref: v,
      style: {
        "--radix-collapsible-content-height": x ? `${x}px` : void 0,
        "--radix-collapsible-content-width": f ? `${f}px` : void 0,
        ...e.style
      },
      children: A && r
    }
  );
});
function V(e) {
  return e ? "open" : "closed";
}
var Ne = J, Ee = X, ye = Z, h = "Accordion", Re = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [B, _e, Pe] = (0,index_099c513a.a)(h), [w, xo] = (0,index_099c513a.b)(h, [
  Pe,
  Y
]), F = Y(), ee = react.forwardRef(
  (e, c) => {
    const { type: o, ...a } = e, r = a, n = a;
    return /* @__PURE__ */ index_099c513a.j.jsx(B.Provider, { scope: e.__scopeAccordion, children: o === "multiple" ? /* @__PURE__ */ index_099c513a.j.jsx(Te, { ...n, ref: c }) : /* @__PURE__ */ index_099c513a.j.jsx(je, { ...r, ref: c }) });
  }
);
ee.displayName = h;
var [oe, we] = w(h), [te, Me] = w(
  h,
  { collapsible: !1 }
), je = react.forwardRef(
  (e, c) => {
    const {
      value: o,
      defaultValue: a,
      onValueChange: r = () => {
      },
      collapsible: n = !1,
      ...i
    } = e, [l, m] = (0,index_099c513a.f)({
      prop: o,
      defaultProp: a ?? "",
      onChange: r,
      caller: h
    });
    return /* @__PURE__ */ index_099c513a.j.jsx(
      oe,
      {
        scope: e.__scopeAccordion,
        value: react.useMemo(() => l ? [l] : [], [l]),
        onItemOpen: m,
        onItemClose: react.useCallback(() => n && m(""), [n, m]),
        children: /* @__PURE__ */ index_099c513a.j.jsx(te, { scope: e.__scopeAccordion, collapsible: n, children: /* @__PURE__ */ index_099c513a.j.jsx(ne, { ...i, ref: c }) })
      }
    );
  }
), Te = react.forwardRef((e, c) => {
  const {
    value: o,
    defaultValue: a,
    onValueChange: r = () => {
    },
    ...n
  } = e, [i, l] = (0,index_099c513a.f)({
    prop: o,
    defaultProp: a ?? [],
    onChange: r,
    caller: h
  }), m = react.useCallback(
    (v) => l((g = []) => [...g, v]),
    [l]
  ), u = react.useCallback(
    (v) => l((g = []) => g.filter((x) => x !== v)),
    [l]
  );
  return /* @__PURE__ */ index_099c513a.j.jsx(
    oe,
    {
      scope: e.__scopeAccordion,
      value: i,
      onItemOpen: m,
      onItemClose: u,
      children: /* @__PURE__ */ index_099c513a.j.jsx(te, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ index_099c513a.j.jsx(ne, { ...n, ref: c }) })
    }
  );
}), [Se, M] = w(h), ne = react.forwardRef(
  (e, c) => {
    const { __scopeAccordion: o, disabled: a, dir: r, orientation: n = "vertical", ...i } = e, l = react.useRef(null), m = (0,index_099c513a.u)(l, c), u = _e(o), g = (0,index_099c513a.e)(r) === "ltr", x = (0,index_099c513a.c)(e.onKeyDown, (b) => {
      if (!Re.includes(b.key))
        return;
      const f = b.target, A = u().filter((O) => !O.ref.current?.disabled), I = A.findIndex((O) => O.ref.current === f), N = A.length;
      if (I === -1)
        return;
      b.preventDefault();
      let d = I;
      const E = 0, j = N - 1, T = () => {
        d = I + 1, d > j && (d = E);
      }, S = () => {
        d = I - 1, d < E && (d = j);
      };
      switch (b.key) {
        case "Home":
          d = E;
          break;
        case "End":
          d = j;
          break;
        case "ArrowRight":
          n === "horizontal" && (g ? T() : S());
          break;
        case "ArrowDown":
          n === "vertical" && T();
          break;
        case "ArrowLeft":
          n === "horizontal" && (g ? S() : T());
          break;
        case "ArrowUp":
          n === "vertical" && S();
          break;
      }
      const pe = d % N;
      A[pe].ref.current?.focus();
    });
    return /* @__PURE__ */ index_099c513a.j.jsx(
      Se,
      {
        scope: o,
        disabled: a,
        direction: r,
        orientation: n,
        children: /* @__PURE__ */ index_099c513a.j.jsx(B.Slot, { scope: o, children: /* @__PURE__ */ index_099c513a.j.jsx(
          index_099c513a.P.div,
          {
            ...i,
            "data-orientation": n,
            ref: m,
            onKeyDown: a ? void 0 : x
          }
        ) })
      }
    );
  }
), _ = "AccordionItem", [Oe, W] = w(_), ae = react.forwardRef(
  (e, c) => {
    const { __scopeAccordion: o, value: a, ...r } = e, n = M(_, o), i = we(_, o), l = F(o), m = (0,index_099c513a.g)(), u = a && i.value.includes(a) || !1, v = n.disabled || e.disabled;
    return /* @__PURE__ */ index_099c513a.j.jsx(
      Oe,
      {
        scope: o,
        open: u,
        disabled: v,
        triggerId: m,
        children: /* @__PURE__ */ index_099c513a.j.jsx(
          Ne,
          {
            "data-orientation": n.orientation,
            "data-state": de(u),
            ...l,
            ...r,
            ref: c,
            disabled: v,
            open: u,
            onOpenChange: (g) => {
              g ? i.onItemOpen(a) : i.onItemClose(a);
            }
          }
        )
      }
    );
  }
);
ae.displayName = _;
var re = "AccordionHeader", ce = react.forwardRef(
  (e, c) => {
    const { __scopeAccordion: o, ...a } = e, r = M(h, o), n = W(re, o);
    return /* @__PURE__ */ index_099c513a.j.jsx(
      index_099c513a.P.h3,
      {
        "data-orientation": r.orientation,
        "data-state": de(n.open),
        "data-disabled": n.disabled ? "" : void 0,
        ...a,
        ref: c
      }
    );
  }
);
ce.displayName = re;
var k = "AccordionTrigger", ie = react.forwardRef(
  (e, c) => {
    const { __scopeAccordion: o, ...a } = e, r = M(h, o), n = W(k, o), i = Me(k, o), l = F(o);
    return /* @__PURE__ */ index_099c513a.j.jsx(B.ItemSlot, { scope: o, children: /* @__PURE__ */ index_099c513a.j.jsx(
      Ee,
      {
        "aria-disabled": n.open && !i.collapsible || void 0,
        "data-orientation": r.orientation,
        id: n.triggerId,
        ...l,
        ...a,
        ref: c
      }
    ) });
  }
);
ie.displayName = k;
var se = "AccordionContent", le = react.forwardRef(
  (e, c) => {
    const { __scopeAccordion: o, ...a } = e, r = M(h, o), n = W(se, o), i = F(o);
    return /* @__PURE__ */ index_099c513a.j.jsx(
      ye,
      {
        role: "region",
        "aria-labelledby": n.triggerId,
        "data-orientation": r.orientation,
        ...i,
        ...a,
        ref: c,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
le.displayName = se;
function de(e) {
  return e ? "open" : "closed";
}
var De = ee, ke = ae, He = ce, Le = ie, qe = le;
const Ve = "faqAccordion", Be = "faqAccordionContent", Fe = "title", We = "intro", Ue = "imageWrapper", $e = "image", Ge = "introText", Ke = "accordionRoot", ze = "accordionItem", Ye = "accordionHeader", Je = "accordionTrigger", Qe = "heading", Xe = "chevron", Ze = "accordionContent", eo = "slideDown", oo = "slideUp", to = "body", no = "openMode", ao = "openItem", ro = "openHeading", co = "openBody", io = "articleMode", p = {
  faqAccordion: Ve,
  faqAccordionContent: Be,
  title: Fe,
  intro: We,
  imageWrapper: Ue,
  image: $e,
  introText: Ge,
  accordionRoot: Ke,
  accordionItem: ze,
  accordionHeader: Ye,
  accordionTrigger: Je,
  heading: Qe,
  chevron: Xe,
  accordionContent: Ze,
  slideDown: eo,
  slideUp: oo,
  body: to,
  openMode: no,
  openItem: ao,
  openHeading: ro,
  openBody: co,
  articleMode: io
};
function so({ item: e }) {
  return /* @__PURE__ */ react.createElement(ke, { value: e.id, className: p.accordionItem }, /* @__PURE__ */ react.createElement(He, { className: p.accordionHeader }, /* @__PURE__ */ react.createElement(Le, { className: p.accordionTrigger }, /* @__PURE__ */ react.createElement("span", { className: p.heading }, e.heading), /* @__PURE__ */ react.createElement(Icon_3122c134.I, { icon: Icon_3122c134.W.CHEVRON_DOWN, className: p.chevron, size: 24, "aria-hidden": !0 }))), /* @__PURE__ */ react.createElement(qe, { className: p.accordionContent }, /* @__PURE__ */ react.createElement("div", { className: p.body }, e.body)));
}
function Ao({
  id: e,
  title: c,
  introText: o,
  image: a,
  imageAlt: r,
  items: n,
  mode: i,
  defaultOpen: l = !1,
  className: m
}) {
  const u = i === "accordion" || i === "faq", v = i === "open", g = i === "article", x = l && n.length > 0 ? n[0].id : void 0, b = o || a;
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(
    Block_9b78bd10.B,
    {
      id: e,
      as: "section",
      topPadding: Block_9b78bd10.B.Padding.SMALL,
      bottomPadding: Block_9b78bd10.B.Padding.SMALL,
      className: (0,app_a75c1d35.c)(p.faqAccordion, m),
      "data-testid": "faq-accordion"
    },
    /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { className: p.faqAccordionContent, flex: !0 }, c && /* @__PURE__ */ react.createElement("h2", { className: (0,app_a75c1d35.c)(p.title, app_a75c1d35.t.headingSection) }, c), b && /* @__PURE__ */ react.createElement("div", { className: p.intro }, a && !g && /* @__PURE__ */ react.createElement("div", { className: p.imageWrapper }, /* @__PURE__ */ react.createElement(
      Image_d6406817.I,
      {
        src: a.imageSrc,
        width: a.width,
        height: a.height,
        altText: r || "",
        imageLoader: a.imageLoader,
        className: p.image
      }
    )), o && /* @__PURE__ */ react.createElement("p", { className: (0,app_a75c1d35.c)(p.introText, app_a75c1d35.t.textsLeadText) }, o)), v && /* @__PURE__ */ react.createElement("div", { className: p.openMode }, n.map((f) => /* @__PURE__ */ react.createElement("div", { key: f.id, className: p.openItem }, /* @__PURE__ */ react.createElement("div", { className: p.openHeading }, f.heading), /* @__PURE__ */ react.createElement("div", { className: p.openBody }, f.body)))), u && /* @__PURE__ */ react.createElement(
      De,
      {
        type: "single",
        collapsible: !0,
        defaultValue: x,
        className: p.accordionRoot
      },
      n.map((f) => /* @__PURE__ */ react.createElement(so, { key: f.id, item: f }))
    ))
  ), g && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("div", { className: p.articleMode }, n.map((f) => /* @__PURE__ */ react.createElement(
    ArticleSection/* ArticleSection */.F,
    {
      key: f.id,
      heading: f.heading,
      bodyText: f.body
    }
  )))));
}

//# sourceMappingURL=FaqAccordion.js.map

// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(8038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
;// CONCATENATED MODULE: ./src/service/schemaOrg/generators/faq.ts
/**
 * Strips HTML tags and converts newlines to spaces for schema
 */ function stripHtmlAndNormalizeText(text) {
    // Remove HTML tags if any
    var cleaned = text.replace(/<[^>]*>/g, "");
    // Convert newlines to spaces
    cleaned = cleaned.replace(/\n+/g, " ");
    // Normalize multiple spaces to single space
    cleaned = cleaned.replace(/\s+/g, " ");
    // Trim whitespace
    return cleaned.trim();
}
/**
 * Generates FAQPage schema from FAQ items
 * 
 * @param items - Array of FAQ items with heading and body
 * @param locale - Language code for inLanguage property
 * @returns FAQPage schema object with @context
 */ function generateFaqSchema(items) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en";
    var mainEntity = items.map(function(item) {
        return {
            "@type": "Question",
            name: item.heading,
            acceptedAnswer: {
                "@type": "Answer",
                text: stripHtmlAndNormalizeText(item.body)
            }
        };
    });
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: mainEntity,
        inLanguage: locale
    };
}

// EXTERNAL MODULE: ./src/components/HtmlParser/HtmlParser.tsx + 2 modules
var HtmlParser = __webpack_require__(8940);
;// CONCATENATED MODULE: ./src/magnolia/components/FaqAccordion/FaqAccordion.tsx











function FaqAccordion(props) {
    var locale = (0,router.useRouter)().locale;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var items = (0,react.useMemo)(function() {
        return (0,magnolia/* jcrMultiFieldToArray */.FE)(props.items).map(function(item) {
            return {
                id: item["@id"],
                heading: item.heading,
                body: item.body
            };
        });
    }, [
        props.items
    ]);
    if (items.length === 0) return null;
    var imageData = props.image ? imageDataHandler(props.image) : undefined;
    // Generate schema only for FAQ mode
    var schema = props.displayMode !== "accordion" ? generateFaqSchema(items, locale || "en") : null;
    var itemsProcessed = items.map(function(item) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
            body: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlParser/* HtmlParser */._, {
                html: item.body
            })
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            schema && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    nonce: "5274deac-df2c-4405-9816-123c1b001d19",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(schema)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Ao, {
                id: props.anchorTag,
                title: props.title,
                introText: props.introText,
                image: imageData,
                imageAlt: props.imageAlt,
                items: itemsProcessed,
                mode: props.displayMode,
                defaultOpen: props.defaultOpen
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/FaqAccordion/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 2579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ P; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3406);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4877);



const l = "section", _ = "section__content", C = "block__content", b = "mobile", u = "desktop", g = "section__content__component", x = "section__content__component__title", T = "section__content__description", D = "section__content__description__footer", E = "section__content__description__body-text", y = "section__content__description__sub-heading", e = {
  section: l,
  sectionContent: _,
  blockContent: C,
  mobile: b,
  desktop: u,
  sectionContentComponent: g,
  sectionContentComponentTitle: x,
  sectionContentDescription: T,
  sectionContentDescriptionFooter: D,
  sectionContentDescriptionBodyText: E,
  sectionContentDescriptionSubHeading: y
};
function h({ content: n }) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "h2",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsComponentTitleBold,
        e.sectionContentComponentTitle
      ),
      itemProp: "name"
    },
    n
  );
}
function N({ content: n }) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "h3",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
        _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsParagraphSubtitleBold,
        e.sectionContentDescriptionSubHeading
      ),
      itemProp: "name"
    },
    n
  );
}
function S(n) {
  const { content: r, isFooterSection: o } = n;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.sectionContentDescriptionBodyText, {
        [_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsLeadText]: o,
        [_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.richText]: o,
        [_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsBodyText]: !o
      }),
      itemProp: "description"
    },
    r
  );
}
function P(n) {
  const { id: r, heading: o, subHeading: a, bodyText: m, isFooterSection: d } = n, p = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    e.sectionContentDescription,
    d ? e.sectionContentDescriptionFooter : ""
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B,
    {
      as: "section",
      id: r,
      topPadding: o ? _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.SMALL : _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.NONE,
      bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.LARGE,
      className: e.section,
      "data-testid": "article-section-block"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Content,
      {
        className: e.sectionContent,
        "data-testid": "article-section-block-content",
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      o && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("article", { className: e.sectionContentComponent }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(h, { content: o })),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "article",
        {
          className: p,
          "data-testid": "article-section-content-description"
        },
        a && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(N, { content: a }),
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(S, { isFooterSection: d, content: m })
      )
    )
  );
}

//# sourceMappingURL=ArticleSection.js.map


/***/ })

}]);